import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useStateValue } from "../state/StateProvider";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";

const hideSidebarPages = ["/login", "/", "/welcome", "/reset-password"];

const Layout = ({ children }) => {
	const [{ user }] = useStateValue();
	const location = useLocation();

	const showSideBar = user && !hideSidebarPages.includes(location.pathname);

	return (
		<div>
			<Header />
			{showSideBar && <Sidebar />}
			<div
				className={`pt-[50px] ${
					showSideBar && "ml-40 bg-gray-100 min-h-screen "
				}`}
			>
				{children}
			</div>
			<Footer />
		</div>
	);
};

export default Layout;
